import { alpha, Menu, styled } from '@mui/material';

const StyledMenu = styled(Menu)`
  & .MuiPaper-root {
    border-radius: 6px;
    margin-top: 8px;
    min-width: ${({ minwidth }) => (minwidth >= 0 ? minwidth : 180)}px;
    color: ${({ theme }) => (theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300])};
    box-shadow:
      rgb(255, 255, 255) 0px 0px 0px 0px,
      rgba(0, 0, 0, 0.05) 0px 0px 0px 1px,
      rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,
      rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
  }
  & .MuiMenu-list {
    padding: 4px 0;
  }
  & .MuiMenuItem-root {
    & .MuiSvgIcon-root {
      font-size: 18px;
      color: ${({ theme }) => theme.palette.text.secondary};
      margin-right: 12px;
    }
    &:active {
      background-color: ${({ theme }) => alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)};
    }
  }
`;

export default StyledMenu;
